import { render, staticRenderFns } from "./BaykedCustomers.vue?vue&type=template&id=de466224&scoped=true"
import script from "./BaykedCustomers.vue?vue&type=script&lang=js"
export * from "./BaykedCustomers.vue?vue&type=script&lang=js"
import style0 from "./BaykedCustomers.vue?vue&type=style&index=0&id=de466224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de466224",
  null
  
)

export default component.exports